import { render } from "./priceComponent.vue?vue&type=template&id=4f04179c&scoped=true"
import script from "./priceComponent.vue?vue&type=script&lang=js"
export * from "./priceComponent.vue?vue&type=script&lang=js"

import "./priceComponent.vue?vue&type=style&index=0&id=4f04179c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f04179c"]])

export default __exports__